// MODULES
import React from "react";

// COMPONENTS
import FieldsCollection from "@components/FieldsCollection/FieldsCollection";
import OptionsList from "@routes/Cob/components/OptionsList/OptionsList";

// HELPERS
import {createClassName} from "@helpers/utils";


export default class Collection extends React.PureComponent {

	render() {
		const {props} = this;
		const {index, fields, onOptionsListChange} = props;
		const classes = createClassName("Cob-Questionnaire-Collection", {
			"first": index === 0,
		});

		return (
			<div className={classes}>
				<h3>PEP - Politiskt exponerad person</h3>

				<div className="description">
					<p>PEP – Person i politiskt utsatt ställning – Har, eller har tidigare haft en hög politisk post, en
						hög statlig befattning eller funktion i ledningen i en internationell organisation, eller en
						nära familjemedlem eller medarbetare med ovanstående befattning. För mer information se
						blankett: Definition – PEP.</p>
				</div>

				<FieldsCollection
					fields={[
						{
							render: (
								<OptionsList
									type="radio"
									orientation="horizontal"
									name="radio_customer_pep"
									description="Är du en politiskt exponerad person/politiskt utsatt person, eller har varit?"
									options={fields.radio_customer_pep.options}
									onChange={onOptionsListChange}
								/>
							),
						},
					]}
				/>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Questionnaire/partners/alfakraft/Fields/collections/CollectionPEP.js